import { Outlet } from 'react-router';
import Header from '../components/header/Header';
import './App.css';
import Footer from '../components/footer/Footer';
import CartSidebar from '../features/cartSidebar/CartSidebar';
import { useSelector } from 'react-redux';
import { selectCartSidebarOpen } from '../features/cartSidebar/cartSidebarSlice';

function App() {
  const cartSidebarIsOpen = useSelector(selectCartSidebarOpen);
  
  return (
    <div className="App">
      <Header />
      <Outlet />
      {cartSidebarIsOpen ? <CartSidebar /> : ""}
      <Footer />
    </div>
  );
}

export default App;
